import React from 'react';
import { useGetCountriesQuery } from 'features/getCountries/api/getCountriesApi';
import { useCacheData } from 'shared/hooks';
import { CountriesType } from 'entities/distribution/types';
import { useDefaultFinanceOperationsTableValues } from 'widgets/financeOperations/lib';
import { DataTableFrontendPagination } from 'shared/ui/Table';
import { columnConfig } from 'widgets/financeOperations/model';
import { useNavigate } from 'react-router-dom';
import { useGetFinanceOperatorsQuery } from 'entities/financeOperations';

export const FinanceOperationsTable = () => {
  const navigate = useNavigate();

  const { data: countryList } = useGetCountriesQuery(null);
  const { data: financeOperationsList } = useGetFinanceOperatorsQuery(null);

  const cachedCountries = useCacheData<CountriesType>(countryList as CountriesType[]) || [];

  const tableData = useDefaultFinanceOperationsTableValues(financeOperationsList || [], cachedCountries);

  const onRowClick = (id: number | string) => {
    navigate(`/settings/finance-operations/${id}`);
  };

  return (
    <DataTableFrontendPagination
      title="Финансовые операторы"
      onRowClick={(id) => onRowClick(id)}
      data={tableData}
      columnConfig={columnConfig}
    />
  );
};
